import React, { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'src/common';
import { Checkbox } from 'antd';
import styles from './index.module.scss';
import { faBuilding } from '@fortawesome/pro-light-svg-icons';
import { BlockTitle } from 'src/shared';
import { useLoadMp, useUpdateMpBuyerTypes } from 'src/models/matchingProfiles/hooks';
import { BuyerType } from '@tendium/prom-types';

interface FormState {
  municipality?: boolean;
  region?: boolean;
  stateAgency?: boolean;
  other?: boolean;
}

interface Props {
  disabled?: boolean;
}
const BuyerTypesFilter: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const { data: mp } = useLoadMp();
  const [updateMpBuyerTypes] = useUpdateMpBuyerTypes();
  const [form] = Form.useForm<FormState>();
  const [buyerTypes, setBuyerTypes] = useState<BuyerType[]>(mp?.buyerTypes || []);

  useEffect(() => {
    form.setFieldsValue({
      municipality: mp?.buyerTypes?.includes(BuyerType.Municipality),
      region: mp?.buyerTypes?.includes(BuyerType.Region),
      stateAgency: mp?.buyerTypes?.includes(BuyerType.StateAgency),
      other: mp?.buyerTypes?.includes(BuyerType.Other)
    });
  }, [form, mp]);

  const onValuesChange = useCallback(
    (changedValues: Partial<FormState>) => {
      const updateBuyerType = (type: BuyerType, value: boolean): void => {
        let updatedBuyerTypes: BuyerType[];
        if (value) {
          updatedBuyerTypes = [...buyerTypes, type];
        } else {
          updatedBuyerTypes = buyerTypes.filter(buyerType => buyerType !== type);
        }
        updateMpBuyerTypes(updatedBuyerTypes);
        setBuyerTypes(updatedBuyerTypes);
      };

      changedValues.municipality !== undefined && updateBuyerType(BuyerType.Municipality, changedValues.municipality);
      changedValues.region !== undefined && updateBuyerType(BuyerType.Region, changedValues.region);
      changedValues.stateAgency !== undefined && updateBuyerType(BuyerType.StateAgency, changedValues.stateAgency);
      changedValues.other !== undefined && updateBuyerType(BuyerType.Other, changedValues.other);
    },
    [buyerTypes, updateMpBuyerTypes]
  );

  return (
    <>
      <BlockTitle
        title={t('ExpiringContracts.buyerTypes')}
        description={t('ExpiringContracts.buyerTypesDesc')}
        icon={{ defaultIcon: faBuilding }}
        className={styles.title}
      ></BlockTitle>

      <Form className={styles.form} onValuesChange={onValuesChange} form={form}>
        <Form.Item name={'municipality'} valuePropName={'checked'}>
          <Checkbox disabled={disabled}>{t('ExpiringContracts.buyerTypeMunicipality')}</Checkbox>
        </Form.Item>
        <Form.Item name={'region'} valuePropName={'checked'}>
          <Checkbox disabled={disabled}>{t('ExpiringContracts.buyerTypeRegion')}</Checkbox>
        </Form.Item>
        <Form.Item name={'stateAgency'} valuePropName={'checked'}>
          <Checkbox disabled={disabled}>{t('ExpiringContracts.buyerTypeStateAgency')}</Checkbox>
        </Form.Item>
        <Form.Item name={'other'} valuePropName={'checked'}>
          <Checkbox disabled={disabled}>{t('ExpiringContracts.buyerTypeOther')}</Checkbox>
        </Form.Item>
      </Form>
    </>
  );
};

export default BuyerTypesFilter;
